module.exports = __webpack_public_path__ + "img/coeurvert_off.5a730178.gif";